module.exports = __webpack_public_path__ + "static/banner-mobile-2b4cf9339d66aeafd02b6930bfe3180d.png";